import { useEffect, useRef, useState } from "react";
import classes from "../homePageNew.module.css";
import { CheckIcon, ChevronDownIcon } from "./icons";

const SWATCH_COLORS = ["#0fbe93", "#2e6aa8", "#b9770e", "#7a5bb0", "#c0392b", "#3e9a5c", "#e8546b", "#4a90d9"];

export function llmSwatchColor(index) {
  return SWATCH_COLORS[index % SWATCH_COLORS.length];
}

/**
 * "LLM: All LLMs" / "LLM: 3 selected" dropdown — checkbox list + Select
 * all / Clear, matching the approved mockup (assets/monitoringhtml.txt).
 * Drives the summary card + LLM performance table + key insights; the
 * chart has its own single-provider selector (MonitoringChart.js), not
 * this one. Rows are PROVIDERS (OpenAI, Google, ...), not exact model
 * versions — see monitoringDerive.js for why (a version upgrade like
 * gpt-5.2 -> gpt-5.4 must stay one continuous selectable row, not split
 * into two that silently lose "previous run" continuity).
 */
export default function MonitoringLlmMultiSelect({ providerLlms, selectedProviders, onChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handleOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [open]);

  const label = selectedProviders.length === providerLlms.length ? "All LLMs" : `${selectedProviders.length} selected`;

  const toggle = (provider) => {
    if (selectedProviders.includes(provider)) {
      const next = selectedProviders.filter((x) => x !== provider);
      onChange(next.length > 0 ? next : [provider]);
    } else {
      onChange([...selectedProviders, provider]);
    }
  };

  return (
    <div className={classes.comboField} ref={rootRef}>
      <span className={classes.comboLabel}>LLM</span>
      <button type="button" className={`${classes.comboTrigger} ${open ? classes.comboTriggerOpen : ""}`} onClick={() => setOpen((v) => !v)}>
        <span className={classes.comboTriggerValue}>{label}</span>
        <span className={`${classes.comboChevron} ${open ? classes.comboChevronOpen : ""}`}>
          <ChevronDownIcon size={12} />
        </span>
      </button>
      {open && (
        <div className={`${classes.comboMenu} ${classes.llmMultiMenu}`} role="listbox">
          <div className={classes.llmMultiActions}>
            <button type="button" onClick={() => onChange(providerLlms.map((p) => p.provider))}>
              Select all
            </button>
            <button type="button" onClick={() => onChange(providerLlms[0] ? [providerLlms[0].provider] : [])}>
              Clear
            </button>
          </div>
          {providerLlms.map((p, i) => {
            const checked = selectedProviders.includes(p.provider);
            return (
              <div key={p.provider} className={classes.llmMultiRow} onClick={() => toggle(p.provider)}>
                <span className={`${classes.llmMultiCheckbox} ${checked ? classes.llmMultiCheckboxChecked : ""}`}>
                  {checked && <CheckIcon size={10} />}
                </span>
                <span className={classes.llmMultiSwatch} style={{ background: llmSwatchColor(i) }} />
                <span>{p.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
